/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteTimelineEventExceptionEnumType } from "./RouteTimelineEventExceptionEnum"
import { RouteTimelineEventStatusEnumType } from "./RouteTimelineEventStatusEnum"
import { RootStoreType } from "./index"


/**
 * RouteTimelineEventSummaryDtoBase
 * auto generated base class for the model RouteTimelineEventSummaryDtoModel.
 */
export const RouteTimelineEventSummaryDtoModelBase = ModelBase
  .named('RouteTimelineEventSummaryDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineEventSummaryDto"), "RouteTimelineEventSummaryDto"),
    status: types.union(types.undefined, RouteTimelineEventStatusEnumType),
    exception: types.union(types.undefined, types.null, RouteTimelineEventExceptionEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineEventSummaryDtoModelSelector extends QueryBuilder {
  get status() { return this.__attr(`status`) }
  get exception() { return this.__attr(`exception`) }
}
export function selectFromRouteTimelineEventSummaryDto() {
  return new RouteTimelineEventSummaryDtoModelSelector()
}

export const routeTimelineEventSummaryDtoModelPrimitives = selectFromRouteTimelineEventSummaryDto().status.exception
